module.exports = __webpack_public_path__ + "pt.svg?24449c1ec1caed45579accf625635f61";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/pt.svg
// module id = 1166
// module chunks = 27